import styled, { css } from 'styled-components';
import { Search as SearchIcon } from '@solent-university/solent-icons';

import { SearchWrapper as FacilitySearchWrapper } from 'Modules/Filters/FacilityListing/FacilityListing.styled';
import { SearchWrapper as CourseListingSearchWrapper } from 'Modules/Filters/CourseListing/CourseListing.styled';
import { SearchWrapper as MediaHubSearchWrapper } from 'Modules/Filters/MediaHub/MediaHub.styled';

export const SearchWrapper = styled.div`
    position: relative;
`;

export const InputWrapper = styled.div`
    position: relative;
    display: flex;
`;

export const SearchBox = styled.input<{ $variant: string }>`
    ${({ theme, $variant }) => css`
        -webkit-appearance: none;
        border: 0.1rem solid ${theme.elements.input.border};
        border-radius: 0.5rem;
        width: 100%;
        height: 100%;
        min-height: 2.5rem;
        padding: 0 3.5rem 0 0.5rem;

        ${CourseListingSearchWrapper} &, ${MediaHubSearchWrapper} & {
            min-height: 2.52rem;
            font-size: 1rem;
        }

        ${$variant === 'button' &&
        css`
            padding: 0 0.5rem;
        `}

        @media ${theme.breakpoints.large.media} {
            min-height: 3.5rem;
        }
    `}
`;

export const Button = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    padding: 0;

    &:hover {
        cursor: pointer;
    }
`;

export const SearchButtonInner = styled(Button)`
    ${({ theme }) => css`
        color: ${theme.colors.primary.hex};
        right: 0;
        border-radius: 0 0.5rem 0.5rem 0;
        height: 100%;
        width: 3.5rem;
        display: grid;
        place-items: center;
    `}
`;

export const StyledSearchIcon = styled(SearchIcon)`
    position: relative;
    width: 50%;
    height: 50%;
`;

export const SearchButtonOuter = styled.button`
    ${({ theme }) => css`
        display: grid;
        place-items: center;
        margin-left: 0.5rem;
        width: 3.5rem;
        min-width: 2.5rem;
        background: ${theme.colors.interactive.hex};
        color: ${theme.colors.interactiveContrast.hex};
        border: none;
        border-radius: 0.5rem;
        text-decoration: none;

        &:hover {
            cursor: pointer;
        }

        @media ${theme.breakpoints.large.media} {
            min-width: 3.5rem;
        }

        ${FacilitySearchWrapper} &, ${CourseListingSearchWrapper} &, ${MediaHubSearchWrapper} & {
            background: ${theme.colors.tertiary.hex};
        }

        ${CourseListingSearchWrapper} &, ${MediaHubSearchWrapper} & {
            width: 2.5rem;
            padding: 0;

            @media ${theme.breakpoints.large.media} {
                min-width: 2.5rem;
            }
        }
    `}
`;

export const ButtonIcon = styled(SearchIcon)`
    width: 70%;
    height: 70%;
    max-width: 2.25rem;
    max-height: 2.25rem;
`;
